commusoftCommon.directive('csdynamictagmodal', ['prefix', '$http', '$modal', function(prefix, $http, $modal) {
    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            title: '@',
            buttonClass: '@',
            buttonValue: '@',
            shouldBeOpen: '=',
            dynamicTags: '=dynamicTags'
        },
        controller: function($scope, $element, $attrs, $transclude) {
            $scope.$watch('shouldBeOpen', function(newVal, oldVal, scope) {
                var modalInstance = null;
                if (newVal) {
                    var elem = $transclude($scope, function() {});
                    $scope.transData = elem;

                    modalInstance = $modal.open({
                        templateUrl: 'template/tagging_modal.html',
                        scope: $scope,
                        controller: CSDynamicTagCtrl
                    })
                }
            });
        }
    }
}]);